"use client";
import styled from "../../../client-utils/styled/index.js";
import { DOUBLE, QUADRUPLE, TRIPLE } from "../../../constants/numbers.consts.js";
import Box from "../../../components/atoms/Box/index.js";
import PopupMenu from "../../../components/molecules/PopupMenu/index.js";
import Skeleton from "../../../components/atoms/Skeleton/index.js";
import Avatar from "../../../components/atoms/Avatar/index.js";
import CardMenuAtom from "../../../components/atoms/CardMenu/index.js";
const coreComponentName = "SdbProfileMenu";
export const Root = styled(PopupMenu, {
    name: coreComponentName,
    slot: "Root",
})();
export const Header = styled(Box, {
    name: coreComponentName,
    slot: "Header",
})(({ theme }) => ({
    marginBottom: theme.spacing(TRIPLE),
}));
export const HeaderTitle = styled(Box, {
    name: coreComponentName,
    slot: "HeaderTitle",
})(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: theme.spacing(TRIPLE),
}));
export const HeaderContent = styled(Box, {
    name: coreComponentName,
    slot: "HeaderContent",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: theme.spacing(QUADRUPLE),
}));
export const HeaderAvatar = styled(Avatar, {
    name: coreComponentName,
    slot: "HeaderAvatar",
})({
    width: 48,
    height: 48,
});
export const HeaderAvatarSkeleton = styled(Skeleton, {
    name: coreComponentName,
    slot: "HeaderAvatarSkeleton",
})({
    width: 48,
    height: 48,
    borderRadius: "50%",
});
export const HeaderSkeletonTextWrapper = styled(Box, {
    name: coreComponentName,
    slot: "HeaderSkeletonTextWrapper",
})(({ theme }) => ({
    width: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(DOUBLE),
}));
export const HeaderSkeletonName = styled(Skeleton, {
    name: coreComponentName,
    slot: "HeaderSkeletonName",
})({
    width: "75%",
});
export const HeaderSkeletonEmail = styled(Skeleton, {
    name: coreComponentName,
    slot: "HeaderSkeletonEmail",
})({
    width: "100%",
});
export const Main = styled(Box, {
    name: coreComponentName,
    slot: "Main",
})();
export const CardMenu = styled(CardMenuAtom, {
    name: coreComponentName,
    slot: "CardMenu",
})();
export const MainSkeleton = styled(Skeleton, {
    name: coreComponentName,
    slot: "MainSkeleton",
})({
    height: 50,
});
export const Footer = styled(Box, {
    name: coreComponentName,
    slot: "Footer",
})();
export const FooterInner = styled(Box, {
    name: coreComponentName,
    slot: "FooterInner",
})({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});
